(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-hero-carousel"] && !window.DesignMode) return;
  try {
    
var heroCarousel = document.querySelector('.product-hero-carousel');
if (heroCarousel) {
  var heroCarouselSlides = heroCarousel.querySelectorAll('div');
  new Flickity(heroCarousel, {
    adaptiveHeight: false,
    wrapAround: (heroCarouselSlides.length > 2),
    contain: true,
    cellAlign: 'left',
    autoPlay: (heroCarousel.dataset.timer === 'false' ? false : heroCarousel.dataset.timer),
    prevNextButtons: (heroCarouselSlides.length > 2),
    setGallerySize: false,
    pageDots: true,
    initialIndex: 0,
    dragThreshold: 1,
    arrowShape: 'M100,47.7 8.9,47.7 38.3,18.2 35,14.9 0,49.9 0.1,50.1 3.3,53.2 35.1,85.1 38.4,81.8 9,52.3 100,52.3z'
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-form"] && !window.DesignMode) return;
  try {
    
  // select the target node
var target = document.getElementById('mce-success-response');

// create an observer instance
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (target.innerHTML === "Thank you for subscribing!") {
      target.innerHTML = "Thank you for registering your warranty!";
    }
  });
});

// configuration of the observer:
var config = { attributes: true, childList: true, characterData: true };

// pass in the target node, as well as the observer options
observer.observe(target, config);

  } catch(e) { console.error(e); }
})();

})();
